import { handleFormSubmit, useAuth, useRequest } from '@polvo-labs/react-auth'
import React from 'react'
import { toast } from 'react-toastify'
import Form from '../../components/Form'
import fields, { AccountFormData } from './fields'

interface Props {
  initialValues: AccountFormData
}

const AccountForm: React.FC<Props> = ({ initialValues }) => {
  const { request } = useRequest()
  const { user, setUser } = useAuth()

  const keys = [
    'avatar.id',
    'name',
    'city',
    'phone',
    'cpf',
    'birth_year',
    'profession',
    'gender',
  ]
  return (
    <Form<AccountFormData>
      buttonLabel="SALVAR"
      fields={fields}
      initialValues={initialValues}
      keys={keys}
      onSubmit={data => {
        const dataSend = { ...data,  cpf: data.cpf ? data.cpf.split('.').join('').split('-').join('').split('/').join(''): ''  }
        return handleFormSubmit({
          request: request({
            method: 'PUT',
            url: `${process.env.REACT_APP_API_URL}/users/${user.id}`,
            data: dataSend,
          }),
          onValidationErrors: () => toast.error('Erros de validacao.'),
          onSuccess: ({ data }) => {
            toast.success('Seus dados foram atualizados com sucesso.')
            setUser?.(data.data)
            // Object.assign(user, data.data)
          },
          onFailure: () => toast.error('Erro ao alterar informações.'),
        })
      }}
    />
  )
}

export default AccountForm
